import { render, staticRenderFns } from "./AltasView.vue?vue&type=template&id=0bfc516f&scoped=true"
import script from "./AltasView.vue?vue&type=script&lang=js"
export * from "./AltasView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfc516f",
  null
  
)

export default component.exports